import Head from 'next/head';
import { Fragment } from 'react';

const Favicon = () => {
   return (
      <Head>
         <Fragment>
            <meta name="application-name" content="Al Madinah" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="default" />
            <meta name="apple-mobile-web-app-title" content="Al Madinah" />
            <meta name="format-detection" content="telephone=no" />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="theme-color" content="#36A270" />
            <link rel="icon" href="/favicon.ico" type="image/x-icon" />
            {/* Apple Touch Icon */}
            <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
            <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
            <link rel="icon" type="image/png" sizes="192x192" href="/android-chrome-192x192.png" />
            <link rel="icon" type="image/png" sizes="512x512" href="/android-chrome-512x512.png" />
            <link rel="manifest" href="/manifest.json" />
         </Fragment>
      </Head>
   );
};
export default Favicon;
